import Api from "./Api";
import Csrf from "./Csrf";

export default {
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/news");
  },
    
  async store(data) {
    await Csrf.getCookie();

    return Api.post("/news",data);
  },
    
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/news/"+id);
  },

  async show(id) {
    await Csrf.getCookie();

    return Api.get("/news/"+id);
  },	
	
  async update(id,data) {
    await Csrf.getCookie();

    return Api.patch("/news/"+id,data);
  },	
	
};